import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'transfer-type',
  templateUrl: './transfer-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class TransferTypeComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }
  @Input() dataProperty = "";
  constructor() { }
  ngOnInit(): void {
  }

  splitCapitalCase(s:string){
    return s.replace(/([A-Z])/g, ' $1').trim();
  }
}
